import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Login() {
  const [formData, setFormData] = useState({ phone: '', password: '' });
  const navigate = useNavigate();

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("http://kolibusiness.com/backend/api-login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      if (data.success) {
        localStorage.setItem("user", JSON.stringify(data.user));

        const cartRes = await fetch(`http://kolibusiness.com/backend/api-cart-fetch.php?user_id=${data.user.id}`);
        const cartData = await cartRes.json();
        localStorage.setItem("cart", JSON.stringify(cartData));

        const wishRes = await fetch(`http://kolibusiness.com/backend/api-wishlist-fetch.php?user_id=${data.user.id}`);
        const wishData = await wishRes.json();
        localStorage.setItem("wishlist", JSON.stringify(wishData));

        alert("Login successful!");
        const redirect = sessionStorage.getItem("redirectAfterLogin") || "/";
        navigate(redirect);
      } else {
        alert(data.message || "Login failed");
      }
    } catch (err) {
      alert("Server error: Unable to connect to backend");
    }
  };

  return (
    <div style={styles.container}>
      <form onSubmit={handleSubmit} style={styles.form}>
        <h2 style={styles.heading}>Welcome Back 👋</h2>
        <p style={styles.subheading}>Login to continue shopping with BigStyles</p>
        <input
          type="text"
          name="phone"
          placeholder="📱 Phone Number"
          onChange={handleChange}
          required
          style={styles.input}
        />
        <input
          type="password"
          name="password"
          placeholder="🔐 Password"
          onChange={handleChange}
          required
          style={styles.input}
        />
        <button type="submit" style={styles.button}>🔓 Login</button>
        <p style={styles.altText}>
          New user? <span onClick={() => navigate("/signup")} style={styles.link}>Create an account</span>
        </p>
      </form>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "85vh",
    background: "#f2f5f9",
    padding: "20px"
  },
  form: {
    background: "#ffffff",
    padding: "35px",
    borderRadius: "12px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
    width: "100%",
    maxWidth: "400px",
    display: "flex",
    flexDirection: "column",
    gap: "20px"
  },
  heading: {
    textAlign: "center",
    fontSize: "26px",
    fontWeight: "600",
    color: "#222"
  },
  subheading: {
    textAlign: "center",
    fontSize: "14px",
    color: "#666"
  },
  input: {
    padding: "12px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    outline: "none",
    transition: "border-color 0.3s",
  },
  button: {
    padding: "12px",
    fontSize: "16px",
    backgroundColor: "#1e88e5",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold"
  },
  altText: {
    fontSize: "14px",
    textAlign: "center",
    marginTop: "10px"
  },
  link: {
    color: "#1e88e5",
    cursor: "pointer",
    fontWeight: "500"
  }
};

export default Login;
